import React from "react";
import ReactDOM from "react-dom";
import Showroom from "@Components/kindsum/showroom";
import styles from "./index.module.less";

const SumShowroomOrBusiness = () => {
  return (
    <section className={styles["showroomMain"]}>
      <div className={styles["content"]}>
        <Showroom type='showroom' />
      </div>
    </section>
  );
};
const $app = document.getElementById("app");
$app && ReactDOM.render(<SumShowroomOrBusiness />, $app);
